import React from 'react'
import { useLGNavigation } from '../hooks/useLGNavigation'
import '../../../assets/stylesheets/back-to-lg-modal.css'

/**
 * Modal component for confirming exit from LG Smart TV app
 * @param {Object} props - Component props
 * @param {boolean} props.isVisible - Whether modal is visible
 * @param {Function} props.onClose - Callback for closing modal
 * @returns {JSX.Element|null} LG Modal component or null
 */
const LGModal = ({ isVisible, onClose }) => {
  const { handlePlatformBack, navigationError, clearNavigationError } =
    useLGNavigation()

  if (!isVisible) return null

  const handleConfirm = async () => {
    const success = await handlePlatformBack()

    // If there was an error, the hook will manage the error state
    // The modal will show the error message automatically
    if (!success) {
      // Error is already set in the hook, just ensure modal stays open
      return
    }
  }

  const handleClose = () => {
    clearNavigationError() // Clear any previous errors when closing
    onClose()
  }

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h5 className="modal-title">Are you sure?</h5>
        </div>
        <div className="modal-body">
          {navigationError ? (
            <div className="error-message">{navigationError}</div>
          ) : (
            <>
              <div className="modal-buttons">
                <button className="button confirm" onClick={handleConfirm}>
                  Exit
                </button>
                <button className="button cancel" onClick={handleClose}>
                  Stay
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default LGModal
